module.exports = __webpack_public_path__ + "static/media/2000px-Aspect-ratio-16x9.svg.c9761904.png";